import { useQuery } from '@tanstack/react-query'

import { getOrganizationChartDepartments } from '@src/api'
import { DefaultApiGetOrganizationChartDepartmentsRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchOrganizationChartDepartments = (
  params: DefaultApiGetOrganizationChartDepartmentsRequest
) => {
  const { axiosInstance } = useAxios()
  const { data, isError, isLoading, refetch } = useQuery({
    enabled: !!params.organizationId,
    queryFn: () => getOrganizationChartDepartments(axiosInstance, params),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_ORGANIZATION_CHART_DEPARTMENTS],
  })

  return { data, isError, isLoading, refetch }
}
